import { VALID_UUID_REGEXP } from './constants';

/**
 * Tests if the passed argument is a valid UUID string.
 * @param val The id to test.
 */
export const isUuid = (val: unknown): val is string =>
  typeof val === 'string' && VALID_UUID_REGEXP.test(val);
